import { render, staticRenderFns } from "./newEditTask.vue?vue&type=template&id=bb979ef0"
import script from "./newEditTask.vue?vue&type=script&lang=js"
export * from "./newEditTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports